import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Timeline, TimelineEvent } from "react-event-timeline";
import moment from "moment";
import { courierBookingStatusDetails } from "../../../../services/helpers/status";
import { normalizeCourierServices } from "../../../../services/helpers/courier";
import { iconView, iconColor, spanStatus } from "../../helpers/tracking";
import SelectCourier from "./selectCourier";
import ReactLoading from "react-loading";
import CopyToClipboard from 'react-copy-to-clipboard';

const truncate50 = (input) => input.length > 25 ? `${input.substring(0, 25)}...` : input;

export default function TrackingResult(props) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [loading, setLoading] = useState(false);

  return (
    <div className="w-full">
      <div className="border rounded">
        <Row className="px-2" >

          <Col md={1} xs={2} className="d-flex justify-content-center align-items-center my-1">
            <i
              className={
                props.data.status ? "fas fa-check-circle fa-2x text-success" : "fas fa-times-circle fa-2x text-muted"
              }
            />
          </Col>

          <Col
            md={4}
            xs={8}
            className="d-flex flex-column justify-content-center my-1"
          >
            <p className={"m-0 p-0 pointer"}>
              <CopyToClipboard
                text={`${props.data.waybillId}`}
                onCopy={() => alert('Sudah dicopy')}
              >
                <b>
                  {props.data.waybillId}
                    <i
                      className={"fas fa-copy ml-2"}
                    />
                </b>
              </CopyToClipboard>
            </p>
            {props.data.status && (
              <p className="m-0 p-0">
                Update Terakhir:{" "}
                {moment(props.data.history[props.data.history.length - 1].eventDate).format(
                  "DD/MM/YYYY"
                )}
              </p>
            )}
          </Col>

          <Col md={2} xs={2} className="d-flex  align-items-center my-1">
            <p className="m-0 ">
              <b>
                {props.data.status
                  ? normalizeCourierServices(props.data.courierCompany, "").companyName
                  : "Tidak Ditemukan"}
              </b>
             
            </p>
          </Col>

          <Col md={4} xs={10} className={`${!props.data.status ? "mt-3 " :""} my-1`}>
            {props.data.status ? (
              <div>
                <p className={`m-0 p-0 ${props.data.status === 'delivered' ? 'text-success font-bold' : 'text-primary'}`}>
                  {spanStatus(props.data.status)}
                </p>
                <p className="m-0 p-0">
                    {truncate50(props.data.history[props.data.history.length - 1].note)}
                  </p>
              </div>
              
            ) : !loading ? (
              <SelectCourier
                resultIndex={props.resultIndex}
                onClickCourier={props.onClickCourier}
                setLoading={setLoading}
                courierList={props.courierList}
              />
            ) : (
              <div className="status-container align-items-center justify-content-center">
                <ReactLoading type={"bubbles"} color={"#3B196C"} height={48} width={48} />
              </div>
            )}
          </Col>
          
          <Col
            md={1}
            xs={2}
            className="d-flex justify-content-center align-items-center my-1"
            onClick={() => setIsCollapsed(!isCollapsed)}
            style={{ cursor: "pointer" }}
          >
            <i
              className={!isCollapsed ? "fas fa-chevron-right" : "fas fa-chevron-down"}
            />
          </Col>
        </Row>
        {isCollapsed ? (
          <div className="px-2 bg-lighter border rounded">

            {props.data.status ? (
              <Timeline className={"bg-lighter px-0"}>
                {props.data.history.map((i, idx) => (
                  <TimelineEvent
                    key={idx}
                    className="bg-lighter mb-1"
                    title={i.note}
                    titleStyle={{ fontWeight: "bold"}}
                    createdAt={moment(i.eventDate).format("DD MMMM YYYY - HH:mm")}
                    bubbleStyle={{
                      color: "white",
                      backgroundColor: "white",
                      borderColor: iconColor(i.status).color,
                    }}
                    iconStyle={iconColor(i.status)}
                    style={{}}
                    icon={<i className={iconView(i.status)} />}
                  />
                ))}
              </Timeline>
            ) : (
              "Resi tidak dapat dilacak. Ada kemungkinan kurir tidak terdeteksi, sudah expired atau belum terdaftar. Coba pilih kurir secara manual."
            )}
          </div>
        ) : null}
      </div>
      
    </div>
  );
}
